import styled from '@emotion/styled';

export const Wrapper = styled.div`
  background: var(--white);
  border-radius: 12px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 900px) {
    max-height: 85vh;
  }
`;

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background: var(--white);
  z-index: 10;
  padding: 24px 24px 0 24px;
  border-radius: 12px 12px 0 0;

  @media (max-width: 900px) {
    padding: 12px 12px 0 12px;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;

  @media (max-width: 900px) {
    padding: 12px;
  }

  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const StickyFooter = styled.div`
  position: sticky;
  bottom: 0;
  background: var(--white);
  z-index: 10;
  padding: 0 24px 24px 24px;
  border-radius: 0 0 12px 12px;
  border-top: 1px solid #f0f0f0;
  padding-top: 20px;

  @media (max-width: 900px) {
    padding: 16px 12px 12px 12px;
    padding-top: 16px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 300px;
`;

export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
`;

export const NoEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SendContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const InvoiceLinkContainer = styled.div`
  margin: 1rem 0;
  padding: 1rem;
  background-color: var(--neut7);
  border-radius: 8px;
`;

export const MainContent = styled.div`
  display: flex;
  gap: 32px;
  min-height: 500px;

  @media (max-width: 900px) {
    flex-direction: column;
    min-height: auto;
    gap: 24px;
  }
`;

export const LeftPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media (max-width: 900px) {
    order: 2;
  }
`;

export const RightPanel = styled.div`
  flex: 1;
  min-width: 0;
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 24px;

  @media (max-width: 900px) {
    order: 1;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionLabel = styled.div`
  margin-bottom: 10px;
`;

export const RecipientCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  label {
    cursor: pointer;
    user-select: none;
  }
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--prim4);
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;

  button {
    flex: 1;
  }

  @media (max-width: 900px) {
    flex-direction: column;

    button {
      width: 100%;
    }
  }
`;
